import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-single-filter',
  templateUrl: './single-filter.component.html',
  styleUrls: ['./single-filter.component.scss']
})
export class SingleFilterComponent{
  @Input() header = false;
  @Output() changeEvent: EventEmitter<any> = new EventEmitter<any>();

  @Input() disabled = false;

  @Input() filterModel: any

  triggerSearch(flag: any) {
    if (this.filterModel.si === this.filterModel.no) {
      if (flag === 'si')
        this.filterModel.no = false
      else
        this.filterModel.si = false
    }
    this.changeEvent.emit();
  }
}
